export const layoutsMisc = {
  confirm: {
    defaultTitle: "¿Estás seguro?",
    confirm: "Confirmar",
    cancel: "Cancelar",
  },
  navPluginWeb: {
    title: "Crear página web",
    stepOf: "{step} de 5",
  },
  saMenu: {
    title: "Acciones del sistema",
    subtitle: "Panel de automatizaciones",
    sectionComms: "COMUNICACIONES",
    firstCheckin: "Envío en primer checkin",
  },
  systemActions: {
    checkin: "Check-in",
  },
  regionMessage: {
    text: "Comunícate con el equipo de soporte para realizar la conexión.",
    contactSupport: "Contactar con soporte",
  },
  selectionScanner: {
    title: "Elige el tipo de documento a escanear",
    idCard: "Cédula de identidad",
    passport: "Pasaporte",
  },
};
